// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"ce74ac9e","154":"3caa7eb8","184":"18a8ec7f","322":"5552978e","463":"6da09054","619":"b36a582f","964":"e3a436bc"}[chunkId] + ".chunk.js";
};